import React from 'react';
import { Button, ButtonProps, alpha, useTheme } from '@mui/material';

interface GlowButtonProps extends ButtonProps {
  glowColor?: 'primary' | 'secondary' | 'error' | 'success';
  disableGlow?: boolean;
}

const GlowButton: React.FC<GlowButtonProps> = ({ 
  children, 
  glowColor = 'primary', 
  disableGlow = false,
  sx,
  variant = 'contained',
  ...props 
}) => {
  const theme = useTheme();
  
  const getGlowColor = () => {
    switch (glowColor) {
      case 'secondary': return theme.palette.secondary.main;
      case 'error': return theme.palette.error.main;
      case 'success': return theme.palette.success.main;
      default: return theme.palette.primary.main;
    }
  };

  const glow = getGlowColor();

  return (
    <Button
      variant={variant}
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 600,
        transition: 'all 0.2s ease-in-out',
        ...(variant === 'contained' && !disableGlow && !props.disabled && {
          boxShadow: `0 0 15px ${alpha(glow, 0.3)}`,
          '&:hover': {
            boxShadow: `0 0 25px ${alpha(glow, 0.5)}`,
            transform: 'translateY(-1px)',
          },
          '&:active': {
            transform: 'translateY(0)',
          }
        }),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default GlowButton;
